import React from 'react';
import { GridFilterInputValue } from '@mui/x-data-grid-premium';
import Box from '@mui/material/Box';
import { DataLoadingCard, PersistentDataGrid } from 'common';

import { useGetPointsQuery } from './pointsEndpoints';

const Points = () => {
  const { data: pointsData = [], isFetching: isFetchingPoints = false } = useGetPointsQuery();

  const formattedRows = (pointsData.points || []).map(point => ({
    ...point,
    isActive: point.isActive ? 'Y' : 'N',
  }));

  const equalsOperator = {
    InputComponent: GridFilterInputValue,
    getApplyFilterFn: filterItem => {
      if (!filterItem.value) return null;
      const filterValue = filterItem.value.trim().toLowerCase();
      return params => params.value?.toString().trim().toLowerCase() === filterValue;
    },
    label: 'equals',
    value: 'equals',
  };

  const columns = [
    {
      field: 'pointIdName',
      headerName: 'ID',
    },
    {
      field: 'pointType',
      headerName: 'Type',
    },
    {
      field: 'nameLong',
      headerName: 'Name',
      width: 200,
    },
    {
      field: 'locationType',
      headerName: 'Location Type',
      renderCell: ({ row }) => {
        return row.locationType ?? '—';
      },
      width: 200,
    },
    {
      field: 'isActive',
      filterOperators: [equalsOperator],
      headerName: 'Active',
    },
  ];

  return (
    <div style={{ padding: 1, pb: 0, width: '100%' }}>
      <div style={{ height: 'calc(100vh - 52px)', marginTop: '50px', padding: 30, width: '100%' }}>
        {isFetchingPoints ? (
          <Box
            sx={{
              p: theme => ({ lg: theme.spacing(4, 1, 1), xs: theme.spacing(9, 3, 4) }),
              textAlign: 'center',
            }}
          >
            <DataLoadingCard type="data" />
          </Box>
        ) : (
          <PersistentDataGrid
            columns={columns}
            getRowId={row => row.pointId}
            loading={isFetchingPoints}
            persist={false}
            rows={formattedRows}
            showFilterButton
          />
        )}
      </div>
    </div>
  );
};

export default Points;
